var removeComponents = function removeComponents(a, b) {
  a && a.iterateComponents(function (a) {
    -1 !== b.indexOf(a.getName().toLowerCase()) || a.getLinkedParent().getState('removed') || a.remove();
  });
};

export { removeComponents };